import React, { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/Spinner';
import Alert from 'react-bootstrap/Alert';

const CategoryList = () => {
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const { encryptedApiCall, API_BASE_URL, isAdmin, logout, user } = useAuth();
    const navigate = useNavigate();

    useEffect(() => {
        fetchCategories();
    }, []);

    const fetchCategories = async () => {
        try {
            setLoading(true);
            // Fetch parent categories (level 1) for navigation
            const data = await encryptedApiCall(`${API_BASE_URL}/categories?level=1`, {
                method: 'GET'
            });
            
            // Ensure data is an array
            let categoriesArray = [];
            if (Array.isArray(data)) {
                categoriesArray = data;
            } else if (data && typeof data === 'object') {
                // Try to extract array from object (e.g., { categories: [...] } or { data: [...] })
                categoriesArray = data.categories || data.data || [];
            }
            
            setCategories(categoriesArray);
        } catch (err) {
            if (err.message && err.message.includes('401')) {
                logout();
                navigate('/login');
                return;
            }
            setError(err.message || 'Failed to fetch categories');
            setCategories([]); // Set empty array on error
        } finally {
            setLoading(false);
        }
    };

    const handleCategoryClick = (categoryId) => {
        // Navigate to child categories view
        navigate(`/categories/${categoryId}/children`);
    };

    if (loading) {
        return (
            <Container className="text-center mt-5">
                <Spinner animation="border" />
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <div className="d-flex justify-content-between align-items-center mb-4">
                <h2>Test Categories</h2>
                <div>
                    <span className="me-3">Welcome, {user?.username}</span>
                    {isAdmin && (
                        <>
                            <span className="badge bg-primary me-3">ADMIN</span>
                            <Button 
                                variant="outline-primary" 
                                size="sm" 
                                onClick={() => navigate('/admin/users')}
                                className="me-2"
                            >
                                Manage Users
                            </Button>
                            <Button 
                                variant="outline-success" 
                                size="sm" 
                                onClick={() => navigate('/admin/import')}
                                className="me-2"
                            >
                                Import Questions
                            </Button>
                            <Button 
                                variant="outline-info" 
                                size="sm" 
                                onClick={() => navigate('/admin/categories')}
                                className="me-2"
                            >
                                Manage Categories
                            </Button>
                        </>
                    )}
                    <Button variant="outline-secondary" size="sm" onClick={logout}>
                        Logout
                    </Button>
                </div>
            </div>

            {error && <Alert variant="danger">{error}</Alert>}

            {!Array.isArray(categories) || categories.length === 0 ? (
                <Alert variant="info">No categories available.</Alert>
            ) : (
                <div className="row">
                    {categories.map((category) => (
                        <div key={category.id} className="col-md-4 mb-3">
                            <Card 
                                style={{ cursor: 'pointer', height: '100%' }}
                                onClick={() => handleCategoryClick(category.id)}
                            >
                                <Card.Body>
                                    <Card.Title>{category.name}</Card.Title>
                                    <Card.Text className="text-muted">
                                        {category.description || 'No description'}
                                    </Card.Text>
                                </Card.Body>
                            </Card>
                        </div>
                    ))}
                </div>
            )}
        </Container>
    );
};

export default CategoryList;

